import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

// Response for summary types (Array of string) [2 items
// 0:"POINTS"
// 1:"PARAGRAPH"
// ]

const aiStoreConfig = {
  id: 'aiStore',
  initialState: {
    aiData: null, // Sets the params for the selected or Clicked AI Feature
    summaryData: null, // Data for the Summary
    summaryTypes: null,
    summaryType: 'POINTS', // Data for the Summary Types,
    errors: null, // Data for the Summary Types,
    showRatingComponent: false
  },
  methods: (set) => ({
    setAIData: (params: any) => {
      set({
        aiData: params
      });
    },
    setSummaryData: (data: any) => {
      set({
        summaryData: data
      });
    },
    setSummaryTypes: (types: any) => {
      set({
        summaryTypes: types
      });
    },
    setSummaryType: (type: string) => {
      set({
        summaryType: type
      });
    },
    setErrors: (errors: any) => {
      set({
        errors: errors
      });
    },
    setShowRatingComponent: (bool: boolean) => {
      set({
        showRatingComponent: bool
      });
    },
    openRatingComponent: () => {
      set({
        showRatingComponent: true
      });
    },
    closeRatingComponent: () => {
      set({
        showRatingComponent: false
      });
    },
    resetData: () => {
      set({
        aiData: null, // Sets the params for the selected or Clicked AI Feature
        summaryData: null, // Data for the Summary
        summaryTypes: null,
        summaryType: 'POINTS', // Data for the Summary Types,
        errors: null, // Data for the Summary Types,
        showRatingComponent: false
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useAIStore = createStore(aiStoreConfig);
